import en from './en.json';
import ru from './ru.json';

export const English = 'en';
export const Russian = 'ru';

export const defaultLanguage = Russian;

export const languages = {
    ru,
    en
};
